<template>
  <div id="puzzle-solution">
    <vue-markdown>The images on the left add an *"-el"* sound to become the images on the right. The missing image is *BEET* + *"EL"*, or **BEETLE**.

    |left|right|
    |:--|:--|
    |BAT|BATTLE|
    |CAT|CATTLE|
    |HAND|HANDLE|
    |PICK|PICKLE|
    |BEET|**BEETLE**|
    </vue-markdown>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
  components: {
    VueMarkdown
  }  
}
</script>